/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ArticlesService } from '../../services/articles.service';
import { Multitenant } from '../../services/multitenant.provider';
import { MetaProvider } from '../../services/meta.provider';
import { Page } from '../../models/page.model';
import { PopUp } from '../../models/popup.model';
import { AuthProvider } from '../../services/auth.provider';
import { PopUpService } from '../../shared/components/pop-up/pop-up.service';
import { IonContent } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: 'contact.html',
  styleUrls: ['contact.scss'],
  // encapsulation: ViewEncapsulation.None
})
export class ContactPage implements OnInit {
  @ViewChild(IonContent) content: IonContent;
  public pageContent: Array<Page> = [];
  public newspaperSubname: string;
  public isActivePage: string;
  public popup: PopUp = new PopUp();
  public tempPopUp: boolean;
  private pageSlug: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private service: ArticlesService,
    private multitenant: Multitenant,
    private auth: AuthProvider,
    private meta: MetaProvider,
    private popUpService: PopUpService
  ) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe( paramMap => {
      this.pageSlug = paramMap.get('slug');

      this.newspaperSubname = this.multitenant.getDomainClass();
      this.service.getPage(this.pageSlug, this.newspaperSubname).subscribe(response => this.pageContent.push(response[0]));

      switch (this.pageSlug) {
        case 'nous-contacter':
          this.meta.setMetaData('contact', this.newspaperSubname);
          break;
        case 'comment-ca-marche':
          this.meta.setMetaData('how-it-works', this.newspaperSubname);
          break;
        case 'qui-sommes-nous':
          this.meta.setMetaData('about-us', this.newspaperSubname);
          break;
        case 'faq':
          this.meta.setMetaData('faq', this.newspaperSubname);
          break;
        case 'mentions-legales':
          this.meta.setMetaData('legal', this.newspaperSubname);
          break;
        case 'cookies':
          this.meta.setMetaData('cookies', this.newspaperSubname);
          break;
        case 'aide-devoirs':
          if (!this.auth.isAuthenticated()) {
            this.router.navigate(['connexion']);
          } else {
            this.meta.setMetaData('aide-devoirs', this.newspaperSubname);
          }
          break;
        default:
          this.meta.setMetaData('contact', this.newspaperSubname);
          break;
      }
    });
  }

  ionViewDidEnter() {
    this.newspaperSubname = this.multitenant.getDomainClass();
    this.isActivePage = 'menu';
    const timeframe = document.getElementsByTagName('iframe');
    if (timeframe.length > 0) {
      for (let i = 0; i < timeframe.length; i++) {
        timeframe[i].width = '100%';
      }
    }

    if ( !this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multitenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  onBottomMenuNotify(message: string): void {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }
}
